// @flow
export { default as cache } from 'universal/reducers/cache';
export { default as ifpApps } from 'client/reducers/ifpApps';
export { default as life } from 'client/reducers/life';
export { default as members } from 'client/reducers/members';
export { default as siteConfigs } from 'client/reducers/siteConfigs';
export { default as surveyData } from 'client/reducers/survey';
export { default as translations } from 'client/reducers/translations';
export { default as user } from 'client/reducers/user';
export { reducer as form } from 'redux-form';
export const brand = (state: string = 'stride') => state;
export const partnerName = (state: string | null = null) => state;
